import '@resources/fontes/fontes.css'
import '@resources/css/report.css'
import Header from '@components/Header/Header'
import Sidebar from '@components/Sidebar/Sidebar'
import React, { useContext, useEffect, useState } from 'react'
import CardSample from '@components/Cards/CardSample/CardSample'
import { BsChevronRight } from 'react-icons/bs'
import { Link, useNavigate } from 'react-router-dom'
import IDonor from '@interfaces/IDonor'
import * as $Donor from '@services/Donor'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { Card } from 'react-bootstrap'
import AuthContext from '@contexts/Auth'

const Favorites: React.FC<any> = () => {
  const { onFavoriteDonor } = useContext(AuthContext)

  const [donors, setDonors] = useState<IDonor[]>([])

  const navigate = useNavigate()

  const SweetAlert = withReactContent(Swal)

  useEffect(() => {
    $Donor.favorites().then(({ data: donors }) => {
      setDonors(donors)
    }).catch((error) => {
      SweetAlert.fire('Erro', error.message || 'Erro ao buscar doadores favoritos', 'error')
      navigate('/')
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleUnfavorite = (id: string) => {
    onFavoriteDonor(id, () => {
      setDonors((prevDonors) => prevDonors.filter((donor) => donor.internal_id !== id))
    })
  }

  return (
    <div className="favorites">
      <Sidebar />
      <main className="with-fixed-nav px-4 pl-xl-0 pr-xl-5">
        <Header />
        <div className="row mt-4">
          <div className="col-auto pr-0">
            <Link to="/" className="text-body d-flex align-items-center">Catálogo</Link>
          </div>
          <div className="col-auto pl-1 pr-1">
            <BsChevronRight size={10} />
          </div>
          <div className="col-auto p-0">
            <a href="#" className="id d-flex align-items-center font-weight-bold">
              Favoritos
            </a>
          </div>
        </div>
        <div className="row mb-3">
          <Card className="w-100 p-4 border-0 shadow-sm rounded-30 mt-5">
            <p className="mb-0">
              Aqui estão os doadores que você mais gostou e favoritou! Lembre-se que a disponibilidade das amostras pode mudar a qualquer momento 😉
            </p>
            <p className="m-0 font-weight-bold">Para garantir amostras do seu doador preferido, faça uma pré-reserva pelo nosso WhatsApp de atendimento personalizado!</p>
          </Card>
        </div>
        <div className="row">
          {donors.map((donor) => (
            <CardSample key={donor.id} item={donor} handleUnfavorite={handleUnfavorite} />
          ))}
        </div>
      </main>
    </div>
  )
}

export default Favorites